import React, { useState } from 'react'
import { FaEdit, FaTrash } from 'react-icons/fa'
import DeleteBanner from '../crudOperations/deleteBanner';
import { displayRemoveAlert } from '../../../redux/slice/formUpdateSlice';
import { useDispatch } from 'react-redux';
import { getImagePath } from '../../../utils/util';
import { consoleLog } from '../../../utils/log-utils';
import { useNavigate } from 'react-router-dom';


function BannerCategoryItem(props) {
  const dispatch=useDispatch();
   const navigate=useNavigate()
  const deleteItem = () => {
    // consoleLog("item",item)
    dispatch(displayRemoveAlert({ displayRemove: true, formData: { item:props.result },type:"banner" }));
  };

  const editItem = () => {
   
    navigate("/addCategoryBanner",{state:{item:props.result}})
  };
  
  return (
    <>
    {
      consoleLog("option key",props.result.option_key)
    }
      
      
        <td>{props.id}</td>
        <td>{props.result.type}</td>
        <td>{props.result.storeName}</td>
        <td>{props.result.name}</td>
        <td>{props.result.option_key}</td>
        <td><img src={getImagePath(props.result.image_path)} className="img-thumbnail" style={{ width: 75 }} /></td>

        {/* <td>
          <div class="form-check form-switch col-lg-12 d-flex justify-content-center">

            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              checked={props.result.status === "ACTIVE" ? true : false}

            />

          </div>

        </td> */}
        <td className="align-middle">
          <div className="d-flex justify-content-center">
<span className="edit-icon-btn" onClick={editItem}>
              <FaEdit />
            </span>
            <span className="delete-icon-btn">
              <FaTrash  onClick={deleteItem} />
            </span>

          </div>
        </td>

      
    </>

  )
}

export default BannerCategoryItem